export const EXTERNAL_LINK_TYPES = ["nonpolopolyURL", "link", "stub"];
